export enum NotificationStatus {
  Failed = 'Failed',
  OptedOut = 'OptedOut',
  Pending = 'Pending',
  Received = 'Received',
  Sent = 'Sent',
  SubstitutionFailed = 'SubstitutionFailed',
}
